<template>
  <filters
    :datePart="datePart"
    @update:datePart="val => datePart = val"
    :classroom_type="classroom_type"
    @update:classroom_type="val => classroom_type = val"
    :session_type="session_type"
    @update:session_type="val => session_type = val"
    :level="level"
    @update:level="val => level = val"
    :month="month"
    @update:month="val => month = val"
    :search="search"
    @update:search="val => search = val"
    :datePartOptions="datePartOptions"
    :sessionOptions="sessionOptions"
    :classroomOptions="classroomOptions"
    :levelOptions="levelOptions"
    :monthOptions="monthOptions"
  />
  <div class="card border-0 my-5">
    <table id="courseTable" class="table table-responsive table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col"><small class="text-secondary">Course</small></th>
            <th scope="col"><small class="text-secondary"> Type</small></th>
            <th scope="col"><small class="text-secondary"> Days & time</small></th>
            <th scope="col"><small class="text-secondary"> Price</small></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody v-if="!isBusy">
          <tr v-for="course in courses.rows" :key="course.id">
              <td>
                <strong class="d-block">
                  {{ course.full_course_name }}
                </strong>
                <small v-if="course.date_start" class="text-nowrap">
                  {{ `${course.date_start.split(' ')[0].split('-')[2]}-${course.date_start.split(' ')[0].split('-')[1]}-${course.date_start.split(' ')[0].split('-')[0]}` }}
                </small>
                <small class="text-nowrap"> to </small>
                <small class="text-nowrap">
                  {{ `${course.date_end.split(' ')[0].split('-')[2]}-${course.date_end.split(' ')[0].split('-')[1]}-${course.date_end.split(' ')[0].split('-')[0]}` }}
                </small>
              </td>
            <td><span class="badge" :class="course.classroom_type === 'classroom' ? 'bg-primary' : 'bg-info'" style="width: 70px">{{ course.classroom_type }}</span></td>
            <td>
              <strong class="d-block">{{ course.days }}</strong>
              <small class="text-nowrap">{{ course.time_from }} - {{ course.time_to }}</small>
              </td>
            <td v-if="course.price" class="text-nowrap">{{ course.price }} NOK</td>
            <td><a :href="`${websiteUrl}/register/?course_id=${course.id}`" class="btn btn-sm text-nowrap btn-success">Sign up</a></td>
          </tr>
        </tbody>
    </table>
      <div v-if="isBusy" class="text-center">
        <div class="spinner-border mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="text-center" v-if="courses.rows.length === 0 && !isBusy">
        <span class="mb-3">No matching records found</span>
      </div>
    <div v-if="courses.rows.length !== 0">
      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-end">
          <li class="page-item prev-page me-1">
            <button @click="page--" :disabled="page === 1" :class="page === 1 ? 'btn-primary' : ''" class="page-link btn btn-sm border-0 text-primary" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item page-number">
            <button class="btn btn-sm" disabled>{{ page }} / {{ courses.totalPages }}</button>
          </li>
          <!-- <li class="page-item">
            <button v-if="page >= 5" class="btn btn-sm" @click="page = 1">1</button>
          </li>
          <button class="page-item btn" disabled v-if="page >= 5">...</button>
          <li v-for="i in courses.totalPages" :key="i" class="page-item">
            <button v-if="i <= 5 && courses.totalPages - page > 5" class="btn btn-sm" :class="page === i ? 'btn-primary' : ''" :disabled="page === i" @click="page = i" href="#">{{ i }}</button>
            <button v-if="i === page && i-1" class="btn btn-sm" :class="page === i+1 ? 'btn-primary' : ''" :disabled="page === i+1" @click="page = i+1" href="#">{{ i + 1 }}</button>
          </li>
          <button class="page-item btn" disabled v-if="courses.totalRecords > 5">...</button>
          <li class="page-item">
            <button v-if="courses.totalPages > 5" class="btn btn-sm" :class="page === courses.totalPages ? 'btn-primary' : ''" :disabled="page === courses.totalPages" @click="page = courses.totalPages">{{ courses.totalPages }}</button>
          </li> -->
          <li class="page-item next-page ms-1">
            <button @click="page++" :disabled="page === courses.totalPages" :class="page === courses.totalPages ? 'btn-primary' : ''" class="page-link btn btn-sm border-0 text-primary" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import Filters from './Filters.vue'

export default {
  components: {
    Filters,
  },
  data() {
    return {
      websiteUrl: process.env.VUE_APP_WEBSITEURL,
      isBusy: false,
      courses: {
        rows: [],
        totalRecords: 0,
        totalPages: 0,
      },
      search: null,
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: true,
      datePart: { label: 'Anytime', value: 'anytime' },
      classroom_type: { label: 'All', value: null },
      session_type: { label: 'All', value: null },
      level: { label: 'All', value: null },
      month: { monthName: 'All', value: null },
      datePartOptions: [
        { label: 'Anytime', value: 'anytime' },
        { label: 'Daytime', value: 'daytime' },
        { label: 'Evening', value: 'evening' },
      ],
      classroomOptions: [
        { label: 'All', value: null },
        { label: 'Classroom', value: 'classroom' },
        { label: 'Online', value: 'online' },
        { label: 'Hybrid', value: 'hybrid' },
      ],
      sessionOptions: [
        { label: 'All', value: null },
        { label: 'Individual', value: 'individual' },
        { label: 'Standard', value: 'standard' },
        { label: 'Intensive', value: 'intensive' },
        { label: 'Grammar', value: 'grammar' },
        { label: 'Exam', value: 'exam' },
        { label: 'Conversation', value: 'conversation' },
      ],
      levelOptions: [
        { label: 'All', value: null },
        { label: 'Beginner', value: 'beginner' },
        { label: 'Intermediate', value: 'intermediate' },
        { label: 'Advanced', value: 'advanced' },
      ],
      monthOptions: [{ monthName: 'All', value: null }],
    }
  },
  watch: {
    search() {
      setTimeout(() => { this.fetchCourses() }, 500) }, perPage() { this.fetchCourses() }, page() { this.fetchCourses() }, sortBy() { this.fetchCourses() }, sortDesc() { this.fetchCourses() }, datePart() { this.fetchCourses() }, classroom_type() { this.fetchCourses() }, session_type() { this.fetchCourses() }, level() { this.fetchCourses() }, month() { this.fetchCourses()
    },
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.forEach((value, key) => {
      if (value) {
        if (key === 'part_date') this.datePart = this.datePartOptions.filter(el => el.value === value)[0]
        if (key === 'session_type') this.session_type = this.sessionOptions.filter(el => el.value === value)[0]
        if (key === 'classroom_type') this.classroom_type = this.classroomOptions.filter(el => el.value === value)[0]
        if (key === 'level') this.level = this.levelOptions.filter(el => el.value === value)[0]
        if (key === 'search') this.search = value
      }
    })
    this.fetchCourses()
  },
  created() {
    const searchParams = new URLSearchParams(document.location.pathname.substr(1))
    fetch(`${process.env.VUE_APP_BASEURI}/courses/years/months`)
    .then(response => response.json().then(res => {
      this.monthOptions = res
      searchParams.forEach((value, key) => {
        this.monthOptions.unshift({ monthName: 'All', value: null })
        if (key === 'month') this.month = this.monthOptions.filter(el => el.value === value)[0]
      })
    }))
  },
  methods: {
    fetchCourses() {
      this.isBusy = true
      const params = {
        search: this.search,
        perPage: this.perPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        time_of_day: this.datePart.value,
        classroom_type: this.classroom_type.value,
        session_type: this.session_type.value,
        rank: this.level.value,
        yearMonth: this.month.value,
        date_start_from: new Date().toISOString().split('T')[0],
      }
      // Delete param when it's null
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key]
      })
      fetch(`${process.env.VUE_APP_BASEURI}/course-list/data?` + new URLSearchParams(params))
      .then(response => response.json().then(res => {
        this.isBusy = false
        this.courses = res
        this.courses.totalPages = !Number.isInteger(this.courses.totalRecords/10) ? Math.round(this.courses.totalRecords/10) + 1 : this.courses.totalRecords/10
      }))
    },
  },
}
</script>
<style scoped lang="css" src="../assets/bootstrap.min.css"></style>
<style scoped>
.table > :not(:first-child) {
    border-top: 0;
}
.btn-primary {
  background-color: #92434e;
}
.btn-primary {
  background-color: #92434e;
  border-color: #92434e;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn-primary:disabled {
  background-color: #92434e;
  border-color: #92434e;
}
.btn-success {
  background-color: #19cb94;
  border-color: #19cb94;
}
.text-primary {
  color: #92434e !important;
}
.text-primary:disabled {
  color: #fff !important;
}
.bg-primary {
  background-color: #92434e !important;
}
.bg-info {
  background-color: #00628f !important;
}
</style>
